import React from 'react';
import PropTypes from 'prop-types';
import {
  ApplyDate,
  FlexWrapper,
  ClickWrapper,
  Title,
  ViewIconBox,
  EditIconBox
} from '../../theme/common_style';
import { EditIcon, ViewIconNew } from '../../theme/SvgIcons';
import { useNavigate } from 'react-router-dom';
import { Skeleton } from 'antd';
import {
  checkPermission,
  convertToLocalTime,
  getCategory,
  getSlot,
  getStatusTag
} from '../../utils/common_functions';
import { actionTypeEnums, LeaveStatusEnum } from '../../utils/constant';
import { useSelector } from 'react-redux';
import { useCurrentModule } from '../../hooks/useCurrentModule';
import styled from '@emotion/styled';

const EmployeeCard = ({ item, loading, handleEdit }) => {
  const navigate = useNavigate();
  const { permissions } = useSelector((state) => state?.userInfo?.data);
  let permissionSection = useCurrentModule();
  const canUpdate = checkPermission(permissionSection, actionTypeEnums.UPDATE, permissions);

  return (
    <FlexWrapper
      gap="10px"
      cursor="default"
      style={{
        padding: '24px',
        borderRadius: '12px',
        backgroundColor: '#ffffff'
      }}>
      {!loading ? (
        <>
          <FlexWrapper justify="space-between" width="100%" cursor="default">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <Title>{item.leave_type}</Title>
              <ApplyDate>
                <span style={{ fontWeight: '700' }}>Apply Date: </span>
                {convertToLocalTime(item?.created_at)}
              </ApplyDate>
            </div>
            {getStatusTag(item.status)}
          </FlexWrapper>
          <FlexWrapperLeave justify="space-between" width="100%" cursor="default">
            <FlexWrapper align="flex-start" gap="2px" direction={'column'} cursor="default">
              <div className="lable-leave">Start Date</div>
              <div className="title-leave">{item?.start_date}</div>
            </FlexWrapper>
            <FlexWrapper align="flex-start" gap="2px" direction={'column'} cursor="default">
              <div className="lable-leave">End Date</div>
              <div className="title-leave">{item?.end_date}</div>
            </FlexWrapper>
            <FlexWrapper align="flex-start" gap="2px" direction={'column'} cursor="default">
              <div className="lable-leave">Leave Category</div>
              <div className="title-leave">{getCategory(item?.leave_category) ?? 'N/A'}</div>
            </FlexWrapper>
            <FlexWrapper align="flex-start" gap="2px" direction={'column'} cursor="default">
              <div className="lable-leave">Leave Slot</div>
              <div className="title-leave">{getSlot(item?.leave_slot) ?? 'N/A'}</div>
            </FlexWrapper>
            <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor={'default'}>
              <ClickWrapper
                onClick={() => {
                  navigate(`/lms/details`, {
                    state: { lms: item }
                  });
                }}>
                <ViewIconBox>
                  <ViewIconNew />
                </ViewIconBox>
              </ClickWrapper>
              {item.status === LeaveStatusEnum?.PENDING && (
                <ClickWrapper onClick={() => handleEdit(item)}>
                  <EditIconBox canUpdate={canUpdate}>
                    <EditIcon />
                  </EditIconBox>
                </ClickWrapper>
              )}
            </FlexWrapper>
          </FlexWrapperLeave>
        </>
      ) : (
        <Skeleton active paragraph={{ rows: 3 }} title={false} />
      )}
    </FlexWrapper>
  );
};

EmployeeCard.propTypes = {
  item: PropTypes.shape({
    emp_id: PropTypes.string.isRequired,
    emp_name: PropTypes.string.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    leave_category: PropTypes.string.isRequired,
    leave_slot: PropTypes.string.isRequired,
    quota: PropTypes.string.isRequired,
    hr: PropTypes.array,
    reporting: PropTypes.array,
    id: PropTypes.string.isRequired,
    leave_type: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired
  }).isRequired,
  loading: PropTypes.bool,
  handleEdit: PropTypes.func
};

export default EmployeeCard;

const FlexWrapperLeave = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-wrap: ${(props) => props.wrap || 'wrap'};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};
  gap: ${(props) => props.gap || '10px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};

  @media (max-width: 1068px) {
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 17px;
  }
  .lable-leave {
    font-family: 'Plus Jakarta Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #9f9f9f;

    @media (max-width: 700px) {
      width: 100%;
      text-align: start;
      display: flex;
      justify-content: start;
      align-items: start;
    }
  }
`;
